import React, { useState, useEffect } from 'react';
import client1 from '../../assets/testimonial/client1.jpg'
import client2 from '../../assets/testimonial/client2.jpg'
import client3 from '../../assets/testimonial/client3.jpg'

const testimonials = [
  {
    id: 1,
    image: client1,
    name: '',
    text: 'I am glad I stumbled upon Glintz photography! He was instantly able to make me, my family at ease and capture the best moments. We love our wedding pictures and videos and would not hesitate to recommend Glintz to anyone who wants a truly professional experience',
  },
  {
    id: 2,
    image: client3,
    name: 'Mrs Bolade',
    text: "We absolutely love our frames and pictures. I can't count the number of times i looked at them."
  },
  {
    id: 3,
    image: client2,
    name: 'Mrs O',
    text: "Choosing Glintz Photography was one of the best decisions we made when choosing Vendors for our wedding. The service, temperament of the photographer and support, customer service and delivery were all to notch. The pictures and videos were beautifully captured. I must specifically commend the ability of Glintz to keep the bride and groom happy, calm and engaged. It is very clear, he is very pasionate about photography. I would recommend and use again!"
  },
];

const TestimonialSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  useEffect(() => {
    const interval = setInterval(goToNextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  const currentTestimonial = testimonials[currentSlide];

  return (
    <div className="bg-white xl:my-20 lg:my-20 md:my-10 my-8">
      <div className="xl:w-5/6 lg:w-5/6 md:w-5/6 w-full px-6 mx-auto
        grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1">

        {/* ── IMAGE BOX — fixed height, image fills via object-cover ── */}
        <div className="xl:h-[500px] lg:h-[500px] md:h-[400px] h-[300px] overflow-hidden">
          <img
            src={currentTestimonial.image}
            alt={`Testimonial ${currentTestimonial.id}`}
            className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-105"
          />
        </div>

        {/* ── QUOTE BOX — same height as image box ── */}
        <div className="xl:h-[500px] lg:h-[500px] md:h-[400px] h-auto min-h-[200px]
          flex flex-col items-center justify-center bg-gray-100 shadow-md xl:px-10 lg:px-8 px-6 py-8">
          <p
            className="xl:text-lg lg:text-base md:text-base text-sm text-center text-gray-700 leading-relaxed"
            style={{ fontFamily: "Muli" }}
          >
            {currentTestimonial.text}
          </p>
          {currentTestimonial.name && (
            <p className="mt-6 text-sm tracking-[.15em] uppercase text-custom-gray-head-text" style={{ fontFamily: "Muli" }}>
              — {currentTestimonial.name}
            </p>
          )}
          <button
            onClick={goToNextSlide}
            className="mt-8 text-xs tracking-[.2em] uppercase text-custom-gray-text border-b border-gray-300 pb-0.5 hover:border-gray-600 transition-colors"
            style={{ fontFamily: "Muli" }}
          >
            Next →
          </button>
        </div>

      </div>
    </div>
  );
};

export default TestimonialSlider;